const expand = {
  userGroup: { select: 'id,name' },
  dynamicEntity: { select: 'id,displayName' },
};

/**
 * OData select/expand for global entity approvers (by user group).
 * Used by createCrudModel via CoreQueries.GlobalEntityApproverByUserGroup.
 */
export default {
  paged: {
    select: 'id,approvalLevel,entityValue,dynamicEntityFieldDisplayText',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select:
      'id,approvalLevel,userGroupId,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName,entityValue',
    expand,
  },
  itemDetail: {
    select:
      'id,approvalLevel,entityValue,updated,created,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
